import { REGISTRATION_TYPE } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Login Api Service
 */
const LoginApiService = {
  // Manual Login
  manual: async (data) => {
    try {
      if (Object.keys(data).length > 0) {
        data['loginType'] = REGISTRATION_TYPE.MANUAL
      }

      return await APIService.post(APIConstants.ENDPOINT_LOGIN, data)
    } catch (err) {
      DebugService.error('Login Api Service: Caught error while login attempt', err, data)
      return { error: { message: err.response?.data?.message || 'Something went wrong' } }
    }
  },

  // Google Login
  google: async (data) => {
    try {
      if (Object.keys(data).length > 0) {
        data['loginType'] = REGISTRATION_TYPE.GOOGLE
      }

      return await APIService.post(APIConstants.ENDPOINT_LOGIN, data)
    } catch (err) {
      DebugService.error('Login Api Service: Caught error while login attempt', err, data)
      return { error: { message: err.response?.data?.message || 'Something went wrong' } }
    }
  },
};

export default LoginApiService;
